/**
 * Shared collection context menu options
 * Used by both CollectionListItem (sidebar) and GraphView (graph nodes)
 */

/**
 * Get collection context menu options
 * @param {Object} collection - Collection object with id and title
 * @param {Function} onCopyTitle - Handler for copying title
 * @param {Function} onUnselectCollection - Handler for unselecting collection
 * @param {Function} onAddFilter - Handler for adding filter
 * @param {Function} onDeleteCollection - Handler for deleting collection
 * @returns {Array} Array of context menu option objects
 */
export function getCollectionContextMenuOptions({
  collection,
  onCopyTitle,
  onUnselectCollection,
  onAddFilter,
  onDeleteCollection
}) {
  return [
    {
      label: 'Copy Title',
      icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>,
      onClick: () => onCopyTitle?.(collection.title),
    },
    { divider: true },
    {
      label: 'Unselect',
      icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>,
      onClick: () => onUnselectCollection?.(collection.id),
    },
    {
      label: 'Filter Out',
      icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
      </svg>,
      onClick: () => onAddFilter?.({
        type: 'exclude-collection',
        collectionId: collection.id,
        collectionTitle: collection.title
      }),
    },
    { divider: true },
    {
      label: 'Delete',
      icon: <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
      </svg>,
      onClick: () => onDeleteCollection?.(collection.id),
      danger: true,
    },
  ];
}
